import { Button } from 'theme-ui';
import { themed } from './NavigationButton.theme';

export const NavigationButton = themed(
  ({ theme, onClick, disabled, direction }) => {
    const isNext = direction === 'next';

    return (
      <Button
        data-comp={NavigationButton.displayName}
        onClick={onClick}
        disabled={disabled}
        sx={{
          ...theme.button,
          ...(disabled ? theme.disabled : {}),
          borderRadius: '0',
          border: 'none',
          minWidth: '0',
          p: 0,
          width: '36px',
          height: '36px',
          boxShadow: 'none',
          backgroundColor: 'transparent',
          transform: isNext ? 'none' : 'rotate(180deg)',
          color: '#222222',
          '&:hover, &:focus': {
            boxShadow: 'none',
            backgroundColor: 'transparent',
            color: '#05000180',
          },
        }}
        aria-label={isNext ? 'Next products' : 'Previous products'}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
        >
          <path
            d="M13.5 7.5L24 18L13.5 28.5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Button>
    );
  }
);

NavigationButton.displayName = 'ProductCarouselToggle-NavigationButton';
